import React, { useEffect, useState } from 'react'
import Header from '../../components/layout/Header'
import Sidebar from '../../components/layout/Sidebar'
import Detail from '../../components/appointment/Detail'
import { useNavigate, useParams } from 'react-router'
import { useDispatch, useSelector } from 'react-redux'
import { AppointDetailAction } from '../../redux/actions/AppointActions'
import Loader from '../../components/layout/Loader'
import axios from 'axios'
import { API_URI } from '../../constants/GlobalConstants'

const DetailAppointment = ({ nav }) => {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const { id } = useParams()

    const userLogin = useSelector(state => state.userSignIn)
    const { error, userInfo } = userLogin
    const detail = useSelector(state => state.appointDetail)
    const { loading, appoint, success } = detail

    const [invoiceSettings, setInvoiceSettings] = useState({
        companyName: "",
        street: "",
        city: "",
        province: "",
        postalCode: "",
        country: "",
        name: "",
        email: "",
        phone: "",
        GST_HST_number: "",
        taxRates: [{ type: "", value: "" }],
        logoUrl: "",
        webAddress: "",
        timezone: "UTC",
    })

    useEffect(() => {
        if (!userInfo) {
            navigate('/sign-in')
        }
        window.scrollTo(0, 0)
    }, [userInfo, navigate])

    useEffect(() => {
        dispatch(AppointDetailAction(id, userInfo.token))
        window.scrollTo(0, 0)

        const fetchSettings = async () => {
            try {
                const { data } = await axios.get(
                    `${API_URI}/api/app/application-settings`,
                    {
                        headers: { Authorization: `Bearer ${userInfo.token}` },
                    }
                )
                if (data.settings) {
                    setInvoiceSettings({
                        companyName: data.settings.companyName || "",
                        street: data.settings.address?.street || "",
                        city: data.settings.address?.city || "",
                        province: data.settings.address?.province || "",
                        postalCode: data.settings.address?.postalCode || "",
                        country: data.settings.address?.country || "",
                        name: data.settings.contact?.name || "",
                        email: data.settings.contact?.email || "",
                        phone: data.settings.contact?.phone || "",
                        GST_HST_number: data.settings.GST_HST_number || "",
                        taxRates: data.settings.taxRates || [{ type: "", value: "" }],
                        logoUrl: data.settings.logoUrl || "",
                        webAddress: data.settings.contact?.webAddress || "",
                        timezone: data.settings.timezone || "UTC",
                    })
                }
            } catch (err) {
                console.error("Failed to fetch settings:", err)
            }
        }
        fetchSettings()
    }, [dispatch, id, userInfo.token])

    return (
        <>
            <div className={nav.isSidebar}>
                <Header nav={nav} />
                <Sidebar nav={nav} />
                {success ? (<Detail p={appoint} settings={invoiceSettings} />) : (<Loader />)}
            </div>
        </>
    )
}

export default DetailAppointment